import DefaultCard from "components/Card";
import IconButton from "components/IconButton";
import styled from "styled-components";
import { COLORS, DEFAULT_TRANSITION_ALL } from "utils/styles";

const Title = styled.h2`
  display: flex;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
`;

const TitleText = styled.span.attrs(() => ({
  className: "mabry-regular",
}))`
  display: block;
  flex-grow: 1;
`;

const CompareButtonWrapper = styled.div``;
const CompareButtonLabel = styled.span.attrs({ className: "mabry-medium" })`
  ${DEFAULT_TRANSITION_ALL};
  opacity: 0;
  font-size: 0.75rem;
  transform: translateY(-5px) translateX(15px);
  display: inline-block;
  margin-right: 2px;
`;

const CompareButton = styled(IconButton)``;

export default styled(DefaultCard)`
  background: ${COLORS.WHITE};
  &:hover,
  &:focus {
    ${CompareButtonLabel} {
      transform: translateY(-5px);
      opacity: 1;
    }
  }
`;

export const CardTitle = function ({ onCompareClick, children, className }) {
  return (
    <Title className={className}>
      <TitleText>{children}</TitleText>
      {onCompareClick ? (
        <CompareButtonWrapper>
          <CompareButton onClick={onCompareClick}>
            <CompareButtonLabel>Compare</CompareButtonLabel>
            <i className="material-icons-round md-dark md-18">tonality</i>
          </CompareButton>
        </CompareButtonWrapper>
      ) : null}
    </Title>
  );
};
